module.exports = __webpack_public_path__ + "components/page-header/static/snow-forecast__logo--white-87231be61f48f6455ef1a011d663464a.png";